// extracted by mini-css-extract-plugin
export default {"bodyLight":"dSVfRQ2x3k+B-L9Q0bU7cg==","bodyDark":"_3TyLbJ0JGqrqNta8BrbZNg=="};